module.exports = __webpack_public_path__ + "img/logo.a0c4c40b.svg";